//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {mapGetters} from 'vuex';
import ButtonBlock from 'components/blocks/Button.vue';
// import ToggleButtons from 'components/blocks/ToggleButtons.vue'
import Slider from 'components/blocks/Slider.vue'

export default{
  block: 'videoFull',
  data() {
    return {
      src: require("@/assets/videos/"+this.data.src),
      playing: false,
      videoEnded: false,
    }
  },
  props: ['data'],
  computed: {
    ...mapGetters([
      'isMobile',
    ]),
    hasLabels() {
      if (!this.data.labels)
        return false; 

      return (this.data.labels.length == 2);
    },
    slider() {
      return (this.isMobile) ? 0 : 1;
    },
    autoplay() { 
      return (typeof this.data.autoplay == 'boolean') ? this.data.autoplay : true;
    },
    loop() {
      return (typeof this.data.loop == 'boolean') ? this.data.loop : true;
    },
    showSlider() {
      return (typeof this.data.showSlider == 'boolean') ? this.data.showSlider : false;
    },
    muted() {
      return (typeof this.data.muted == 'boolean') ? this.data.muted : true;
    }
  },
  components: {
    Slider,
    // ToggleButtons,
    ButtonBlock,
  },
  methods: {
    getSrc() {
      if (this.isMobile) {
        if (this.data.srcMobile){
          return require("@/assets/videos/"+this.data.srcMobile)
        } else {
          return require("@/assets/videos/"+this.data.src);
        }
      } else {
        return require("@/assets/videos/"+this.data.src);
      }
    },
    getBlockModifiers() {
      let bms = this.block;
      if (this.data.blockModifiers) {
        this.data.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }

      return bms;
    },
    slide(right){
      this.src = (right) ? require("@/assets/videos/"+this.data.src) : require("@/assets/videos/"+this.data.srcMobile);
      this.videoElement.muted = this.muted;
      this.videoElement.loop = true;
      this.videoElement.play();
      this.playing = true;
    },
    playVideo() {
      this.videoElement.play();
      this.playing = true;
      this.pauseButtonTimeout();
    },
    playAgain() {
      this.videoEnded = false;
      this.videoElement.play();
    },
    pauseVideo() {
      this.videoElement.pause();
      this.playing = false;
      this.$pauseButton.classList.remove('m-visible');
    },
    toggleVideo() {
      if (this.autoplay)
        return;

      if (this.playing) {
        // this.pauseVideo();
        this.pauseButtonTimeout();
      } else {
        this.playVideo();
      }
    },
    mouseoverVideo() {
      this.pauseButtonTimeout();
    },
    mouseleaveVideo() {
      if (!this.autoplay && this.playing) {
        if (this.$pauseButton.classList.contains('m-visible')) {
          this.$pauseButton.classList.remove('m-visible');
        }
      }
    },
    pauseButtonTimeout() {
      if (!this.autoplay && this.playing) {
        this.$pauseButton.classList.add('m-visible');

        setTimeout(() => {
          this.$pauseButton.classList.remove('m-visible');
        }, 1000);
      }
    },
    endOfVideo() {
      if (!this.autoplay && this.playing && !this.loop) {
        this.videoEnded = true;
      }
    }
  },
  mounted() {
    this.src = this.getSrc();

    this.slider = (this.isMobile) ?  0 : 1;

    this.videoElement = this.$el.querySelector('.videoFull-video');

    // this.videoElement.load();
    this.videoElement.currentTime = 0;
    this.videoElement.muted = this.muted;

    if (this.loop){
      this.videoElement.loop = true;
    }

    if (this.autoplay){
      this.videoElement.autoplay = true;
      this.playing = true;
    } else {
      // Get control buttons (in case the video is not autoplay)
      this.$playButton = this.$el.querySelector('#play');
      this.$pauseButton = this.$el.querySelector('#pause');
      // this.videoElement.load();
    }
  }
}



// WEBPACK FOOTER //
// ./components/combinedBlocks/Video.vue